import { useEffect, useState } from "react";
import { useBuildingStore } from "@/hooks/useBuildingStore";

export function useBuildingCount(orgId?: string) {
  const store = useBuildingStore();
  const [data, setData] = useState<number | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    let mounted = true;
    setIsLoading(true);
    setError(null);
    store
      .countBuildings(orgId)
      .then((count: number) => {
        if (mounted) setData(count);
      })
      .catch((e: unknown) => {
        if (mounted) setError(e instanceof Error ? e : new Error(String(e)));
      })
      .finally(() => {
        if (mounted) setIsLoading(false);
      });
    return () => {
      mounted = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orgId]);

  return { data, isLoading, error } as const;
}
